/**
 * ICU-compliant date formatters using native Intl API
 * These replace date-fns formatters for full Unicode CLDR compliance
 */

interface ICUOptions {
  locale?: string;
}
/**
 * Format month and year for calendar header (e.g., "Jan 2025", "Januar 2025")
 * Replaces date-fns format(date, 'MMM y', options)
 */
export const formatCaption = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    year: 'numeric',
  }).format(date);
};

/**
 * Format month name only (e.g., "Jan", "Januar")
 * Replaces date-fns format(date, 'MMM', options)
 */
export const formatMonthCaption = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
  }).format(date);
};

/**
 * Format day number (1-31)
 * Used for calendar day cells
 */
export const formatDay = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
  }).format(date);
};

/**
 * Format weekday names (e.g., "Mon", "Mo", "Lu")
 * Used for calendar column headers
 */
export const formatWeekdayName = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    weekday: 'short',
  }).format(date);
};

/**
 * Format full month name (e.g., "January", "Januar")
 * Used in month picker
 */
export const formatMonthName = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
  }).format(date);
};
/**
 * Format year only (e.g., "2025")
 * Used in year picker
 */
export const formatYearCaption = (date: Date, options?: ICUOptions) => {
  const locale = options?.locale || 'en';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
  }).format(date);
};
